import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { InternalProcessService } from 'src/app/app-core/services/internal-process.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IInternalProcessUserFeedbackSchema } from 'src/app/interfaces/internalProcess.interfaces';
@Component({
  selector: 'app-internal-process-feedback',
  templateUrl: './internal-process-feedback.component.html',
  styleUrls: ['./internal-process-feedback.component.scss'],
  providers: [MessageService, InternalProcessService]
})
export class InternalProcessFeedbackComponent implements OnInit {

  selectedRating: number;
  suggestions: string;
  userId: string;
  internalProcessId: string;
  isProcessAlreadyRated: boolean = false;
  isRatingSubmitted: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private messageService: MessageService,
    private internalProcessService: InternalProcessService,
    public global: GlobalService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const decodedProcessId = decodeURIComponent(params['internalProcess']);
      const decodedUserId = decodeURIComponent(params['user']);

      this.internalProcessId = CryptoJS.AES.decrypt(decodedProcessId, environment.cryptoSecret).toString(CryptoJS.enc.Utf8);
      this.userId = CryptoJS.AES.decrypt(decodedUserId, environment.cryptoSecret).toString(CryptoJS.enc.Utf8);

      this.isProcessAlreadyEvaluated(this.internalProcessId).subscribe(isEvaluated => {
        if (isEvaluated) {
          this.isProcessAlreadyRated = true;
          this.messageService.add({
            severity: 'error',
            icon: 'ph ph-warning',
            closable: true,
            life: 5000,
            summary: 'Não é possível avaliar este processo interno!',
            detail: 'O processo que você está tentando avaliar já foi avaliado.',
          });

          setTimeout(() => {
            this.global.router.navigate(['/principal'])
          }, 4000)
        }
      });
    });
  }

  isProcessAlreadyEvaluated(internalProcessId: string | number): Observable<boolean> {
    return this.internalProcessService.listProcessFeedback(Number(internalProcessId))
      .pipe(
        map((response: any) => response.data != null)
      );
  }

  submitFeedback() {

    const userFeedbackData: IInternalProcessUserFeedbackSchema = {
      rating: this.selectedRating,
      suggestions: this.suggestions,
      userId: this.userId,
      internalProcessId: this.internalProcessId
    }

    if (!this.selectedRating) {
      this.messageService.add({
        severity: 'error',
        icon: 'ph ph-warning',
        closable: true,
        life: 3000,
        summary: 'Não foi possível enviar feedback.',
        detail: 'Selecione uma avaliação antes de envir seu feedback.',
      });
    }


    this.internalProcessService.submitUserFeedback(userFeedbackData).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.isRatingSubmitted = true;
          this.messageService.add({
            severity: 'success',
            icon: 'ph ph-warning',
            closable: true,
            life: 3000,
            summary: 'Feedback enviado com sucesso!',
            detail: 'Obrigado por compartilhar sua opinião.',
          });

          setTimeout(() => {
            this.global.router.navigate(['/principal'])
          }, 4000)
        }
      }
    })
  }
}
